import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaWpforms } from 'react-icons/fa';
import { MdDashboard } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { BiMenuAltLeft } from "react-icons/bi";
import Commonheader from './CommonUtils/Commonheader';

export const MenuBar = ({ children }) => {

    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
    const [activeMenu, setActiveMenu] = useState("Dashboard");
    // ------------------------------------------------------------------
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 990);

    const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 990);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [menuData]);

    const navigate = useNavigate();
    const iconMap = {
        RusaDashboard: <MdDashboard size={20} />,
        RusaEntryForm: <FaWpforms size={20} />
    };


    return (<>
        <div className="dashboard-container vh-100">


            <Commonheader />

            <div className="main-area">
                {menuData.some(item => item.role_id == 1 || item.role_id == 4) && (
                    <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
                        <Button
                            className="toggle-btn"
                            onClick={() => setSidebarOpen(!sidebarOpen)}
                        >
                            {sidebarOpen ? (
                                <img
                                    src="../images/toggle1.svg"
                                    className="img-fluid toggle1"
                                    alt="toggle1"
                                />
                            ) : (
                                <span>
                                    <img
                                        src="../images/toggle2.svg"
                                        className="img-fluid toggle2"
                                        alt="toggle2"
                                    />
                                </span>
                            )}
                        </Button>
                        <ul className={`sidebar-menu ${sidebarOpen ? "open" : "closed"}`}>
                            {menuData
                                .filter(item => item.role_id === 1 || item.role_id === 4)
                                .sort((a, b) => a.order_by - b.order_by)
                                .map((item) => (

                                    <li
                                        key={item.service_id}
                                        role="button"         // tells screen readers it's clickable
                                        tabIndex={0}          // makes it focusable via keyboard
                                        className={activeMenu === item.service_name ? "active" : ""}
                                        onClick={() => {
                                            setActiveMenu(item.service_name);
                                            navigate(`/${item.service_name}`);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                setActiveMenu(item.service_name);
                                                navigate(`/${item.service_name}`);
                                            }
                                        }}
                                    >
                                        <span className="menu-icon">
                                            {iconMap[item.service_name] || <BiMenuAltLeft size={20} />}
                                        </span>
                                        <span className="menu-text">{item.display_name}</span>
                                    </li>

                                ))}
                        </ul>
                        <div className="sidebar-footer">
                            <p className="mb-0">
                                Powered By{" "}
                                <a href="https://apcfss.in/" target="_blank">
                                    <img
                                        src="../images/dashboard-footer.png"
                                        alt=""
                                        className="img-fluid"
                                    />
                                </a>
                            </p>
                        </div>
                    </aside>
                )}

                <main className="content-box">
                    <div className="inner-content">
                        {children}
                    </div>
                </main>
            </div >
            {/* <div className="footer-brand-logo">
                <p>Design and Developed by</p>
                <a href="https://apcfss.in/" target="_blank"><img src="../images/apcfss-logo-white.svg" className="img-fluid" alt="apcfss-logo-white" /></a>
            </div> */}
        </div>
        {/* <PublicFooter /> */}
    </>
    );
};
